import { Navigate, ScrollRestoration, useLocation } from "react-router-dom";
import DefaultLayout from "../layout/DefaultLayout/DefaultLayout";
import { useProfileStore } from "../store/useUserStore";
import { useEffect } from "react";

const PrivateRoutes = () => {
    const location = useLocation();
    const authLogin = localStorage.getItem("token")
    const {profile, fetchProfile} = useProfileStore((state) => state)

    useEffect(() => {
        // Only fetch if not already fetched
        if (!profile) {
            fetchProfile()
        }
    }, [profile, fetchProfile])


    if (authLogin === null) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return (
        <>
        <ScrollRestoration/>
        <DefaultLayout/>
        </>
    )
}

export default PrivateRoutes;